"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const ConfigItemCard_1 = __importDefault(require("./ConfigItemCard"));
const { Title } = antd_1.Typography;
const ConfigItemsList = ({ configItems, isEditable, checkedOutBy, activeLocale, activeLocales, onAdd, onEdit, }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(configItems === null || configItems === void 0 ? void 0 : configItems.length) > 0 && ((0, jsx_runtime_1.jsx)(Title, Object.assign({ level: 5, style: { color: 'var(--color-primary)' } }, { children: "Config Items" }))), (configItems === null || configItems === void 0 ? void 0 : configItems.length) > 0 && configItems
            .sort((a, b) => a.configItemName.localeCompare(b.configItemName))
            .map((_a) => {
            var { configItemId } = _a, rest = __rest(_a, ["configItemId"]);
            return ((0, jsx_runtime_1.jsx)(ConfigItemCard_1.default, { isEditable: isEditable, configItem: Object.assign({ configItemId }, rest), checkedOutBy: checkedOutBy, activeLocale: activeLocale, activeLocales: activeLocales, onAdd: onAdd, onEdit: onEdit }, configItemId));
        })] }));
exports.default = ConfigItemsList;
